/**
 * Catalogo regioni e province italiane.
 * Quando l'utente seleziona la regione, le province filtrate compaiono nel dropdown provincia.
 */

export interface Provincia {
  sigla: string;
  nome: string;
}

export interface RegioneItaliana {
  nome: string;
  province: Provincia[];
}

export const REGIONI_ITALIANE: RegioneItaliana[] = [
  { nome: 'Abruzzo', province: [
    { sigla: 'AQ', nome: "L'Aquila" }, { sigla: 'CH', nome: 'Chieti' },
    { sigla: 'PE', nome: 'Pescara' }, { sigla: 'TE', nome: 'Teramo' },
  ]},
  { nome: 'Basilicata', province: [
    { sigla: 'MT', nome: 'Matera' }, { sigla: 'PZ', nome: 'Potenza' },
  ]},
  { nome: 'Calabria', province: [
    { sigla: 'CZ', nome: 'Catanzaro' }, { sigla: 'CS', nome: 'Cosenza' },
    { sigla: 'KR', nome: 'Crotone' }, { sigla: 'RC', nome: 'Reggio Calabria' },
    { sigla: 'VV', nome: 'Vibo Valentia' },
  ]},
  { nome: 'Campania', province: [
    { sigla: 'AV', nome: 'Avellino' }, { sigla: 'BN', nome: 'Benevento' },
    { sigla: 'CE', nome: 'Caserta' }, { sigla: 'NA', nome: 'Napoli' },
    { sigla: 'SA', nome: 'Salerno' },
  ]},
  { nome: 'Emilia-Romagna', province: [
    { sigla: 'BO', nome: 'Bologna' }, { sigla: 'FE', nome: 'Ferrara' },
    { sigla: 'FC', nome: 'Forlì-Cesena' }, { sigla: 'MO', nome: 'Modena' },
    { sigla: 'PR', nome: 'Parma' }, { sigla: 'PC', nome: 'Piacenza' },
    { sigla: 'RA', nome: 'Ravenna' }, { sigla: 'RE', nome: 'Reggio Emilia' },
    { sigla: 'RN', nome: 'Rimini' },
  ]},
  { nome: 'Friuli-Venezia Giulia', province: [
    { sigla: 'GO', nome: 'Gorizia' }, { sigla: 'PN', nome: 'Pordenone' },
    { sigla: 'TS', nome: 'Trieste' }, { sigla: 'UD', nome: 'Udine' },
  ]},
  { nome: 'Lazio', province: [
    { sigla: 'FR', nome: 'Frosinone' }, { sigla: 'LT', nome: 'Latina' },
    { sigla: 'RI', nome: 'Rieti' }, { sigla: 'RM', nome: 'Roma' },
    { sigla: 'VT', nome: 'Viterbo' },
  ]},
  { nome: 'Liguria', province: [
    { sigla: 'GE', nome: 'Genova' }, { sigla: 'IM', nome: 'Imperia' },
    { sigla: 'SP', nome: 'La Spezia' }, { sigla: 'SV', nome: 'Savona' },
  ]},
  { nome: 'Lombardia', province: [
    { sigla: 'BG', nome: 'Bergamo' }, { sigla: 'BS', nome: 'Brescia' },
    { sigla: 'CO', nome: 'Como' }, { sigla: 'CR', nome: 'Cremona' },
    { sigla: 'LC', nome: 'Lecco' }, { sigla: 'LO', nome: 'Lodi' },
    { sigla: 'MN', nome: 'Mantova' }, { sigla: 'MI', nome: 'Milano' },
    { sigla: 'MB', nome: 'Monza e Brianza' }, { sigla: 'PV', nome: 'Pavia' },
    { sigla: 'SO', nome: 'Sondrio' }, { sigla: 'VA', nome: 'Varese' },
  ]},
  { nome: 'Marche', province: [
    { sigla: 'AN', nome: 'Ancona' }, { sigla: 'AP', nome: 'Ascoli Piceno' },
    { sigla: 'FM', nome: 'Fermo' }, { sigla: 'MC', nome: 'Macerata' },
    { sigla: 'PU', nome: 'Pesaro e Urbino' },
  ]},
  { nome: 'Molise', province: [
    { sigla: 'CB', nome: 'Campobasso' }, { sigla: 'IS', nome: 'Isernia' },
  ]},
  { nome: 'Piemonte', province: [
    { sigla: 'AL', nome: 'Alessandria' }, { sigla: 'AT', nome: 'Asti' },
    { sigla: 'BI', nome: 'Biella' }, { sigla: 'CN', nome: 'Cuneo' },
    { sigla: 'NO', nome: 'Novara' }, { sigla: 'TO', nome: 'Torino' },
    { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' }, { sigla: 'VC', nome: 'Vercelli' },
  ]},
  { nome: 'Puglia', province: [
    { sigla: 'BA', nome: 'Bari' }, { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
    { sigla: 'BR', nome: 'Brindisi' }, { sigla: 'FG', nome: 'Foggia' },
    { sigla: 'LE', nome: 'Lecce' }, { sigla: 'TA', nome: 'Taranto' },
  ]},
  { nome: 'Sardegna', province: [
    { sigla: 'CA', nome: 'Cagliari' }, { sigla: 'NU', nome: 'Nuoro' },
    { sigla: 'OR', nome: 'Oristano' }, { sigla: 'SS', nome: 'Sassari' },
    { sigla: 'SU', nome: 'Sud Sardegna' },
  ]},
  { nome: 'Sicilia', province: [
    { sigla: 'AG', nome: 'Agrigento' }, { sigla: 'CL', nome: 'Caltanissetta' },
    { sigla: 'CT', nome: 'Catania' }, { sigla: 'EN', nome: 'Enna' },
    { sigla: 'ME', nome: 'Messina' }, { sigla: 'PA', nome: 'Palermo' },
    { sigla: 'RG', nome: 'Ragusa' }, { sigla: 'SR', nome: 'Siracusa' },
    { sigla: 'TP', nome: 'Trapani' },
  ]},
  { nome: 'Toscana', province: [
    { sigla: 'AR', nome: 'Arezzo' }, { sigla: 'FI', nome: 'Firenze' },
    { sigla: 'GR', nome: 'Grosseto' }, { sigla: 'LI', nome: 'Livorno' },
    { sigla: 'LU', nome: 'Lucca' }, { sigla: 'MS', nome: 'Massa-Carrara' },
    { sigla: 'PI', nome: 'Pisa' }, { sigla: 'PT', nome: 'Pistoia' },
    { sigla: 'PO', nome: 'Prato' }, { sigla: 'SI', nome: 'Siena' },
  ]},
  { nome: 'Trentino-Alto Adige', province: [
    { sigla: 'BZ', nome: 'Bolzano' }, { sigla: 'TN', nome: 'Trento' },
  ]},
  { nome: 'Umbria', province: [
    { sigla: 'PG', nome: 'Perugia' }, { sigla: 'TR', nome: 'Terni' },
  ]},
  { nome: "Valle d'Aosta", province: [
    { sigla: 'AO', nome: 'Aosta' },
  ]},
  { nome: 'Veneto', province: [
    { sigla: 'BL', nome: 'Belluno' }, { sigla: 'PD', nome: 'Padova' },
    { sigla: 'RO', nome: 'Rovigo' }, { sigla: 'TV', nome: 'Treviso' },
    { sigla: 'VE', nome: 'Venezia' }, { sigla: 'VR', nome: 'Verona' },
    { sigla: 'VI', nome: 'Vicenza' },
  ]},
];

export function findRegioneByProvinciaSigla(sigla: string): RegioneItaliana | undefined {
  return REGIONI_ITALIANE.find((r) => r.province.some((p) => p.sigla === sigla.toUpperCase()));
}

export function findProvinceByRegioneNome(nome: string): Provincia[] {
  const r = REGIONI_ITALIANE.find((reg) => reg.nome === nome);
  return r?.province ?? [];
}
